export default __webpack_public_path__ + "static/simple-area-71e7d4cd3fda17cc41157839cd5c079c.png";